<template>
	<div>
		<b-input-group>
			<b-form-input
				:type="inputType"
				:id="fieldInfo.id"
				:value="value"
				:state="state"
				v-model="proxyValue"
				:name="fieldInfo.name"
				@blur="emitBlur"
				:readonly="!active"
				:placeholder="fieldInfo.placeholder"
				v-mask="fieldInfo.mask"
				:disabled="disabled"
				@keypress.enter="emitEnterEvent"
				@keydown="preventSpace"
				autocomplete="new-password"
			/>
			<b-input-group-append>
				<b-button tabindex="-1" variant="solid" @click="changeEye" :class="buttonClass">
					<b-icon :icon="passwordIcon" variant="dark" />
				</b-button>
			</b-input-group-append>
			<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`" :state="state">
				{{ errors[fieldInfo.name] }}
			</b-form-invalid-feedback>
		</b-input-group>
	</div>
</template>

<script>
export default {
	props: {
		fieldInfo: {
			type: Object
		},
		value: {
			type: [String, Number]
		},
		state: {
			type: Boolean
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		disabled: {
			type: [Boolean, Function],
			required: false
		}
	},
	data() {
		return { active: true, passwordShown: false };
	},
	computed: {
		buttonClass() {
			if (this.state) {
				return "eyeButton-green";
			} else if (this.state === false) {
				return "eyeButton-red";
			} else {
				return "eyeButton";
			}
		},
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.fieldInfo.name);
			}
		},

		passwordIcon: function () {
			if (this.passwordShown) return "eye-slash";
			return "eye";
		},

		inputType: function () {
			if (this.passwordShown) return "text";
			return "password";
		}
	},
	methods: {
		getValue: function () {
			this.$emit("value", this.value);
		},
		emitBlur: function () {
			this.$emit("change", this.fieldInfo.name);
			this.$emit("blur", this.fieldInfo);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		emitEnterEvent: function () {
			this.$emit("enterPress");
		},
		preventSpace(event) {
			if (event.key === " ") {
				event.preventDefault();
			}
		},
		changeEye: function () {
			this.passwordShown = !this.passwordShown;
		}
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>

<style>
.eyeButton,
.eyeButton:hover,
.eyeButton:focus,
.eyeButton:active {
	background-color: white !important;
	color: #1c1637;
	border-left: none !important;
	border-color: #ced4da !important;
	box-shadow: initial;
	border-top-right-radius: 0.25rem !important;
	border-bottom-right-radius: 0.25rem !important;
}

.eyeButton-green,
.eyeButton-green:hover,
.eyeButton-green:focus,
.eyeButton-green:active {
	background-color: white !important;
	color: #1c1637;
	border-left: none !important;
	border-color: #28a745 !important;
	box-shadow: initial;
	border-top-right-radius: 0.25rem !important;
	border-bottom-right-radius: 0.25rem !important;
}

.eyeButton-red,
.eyeButton-red:hover,
.eyeButton-red:focus,
.eyeButton-red:active {
	background-color: white !important;
	color: #1c1637;
	border-left: none !important;
	border-color: #dc3545 !important;
	box-shadow: initial;
	border-top-right-radius: 0.25rem !important;
	border-bottom-right-radius: 0.25rem !important;
}
</style>
